import URI from "urijs";
import AppConfig from "util/AppConfig";
const setAssetPrefix = (productionPrefix) => {
  const assetPrefix = AppConfig.gl2DevMode() ? "/" : productionPrefix;
  if (AppConfig.gl2AppPathPrefix() !== void 0) {
    __webpack_public_path__ = URI.joinPaths(AppConfig.gl2AppPathPrefix(), assetPrefix).path() || assetPrefix;
  } else {
    throw new Error(
      `Unable to determine app prefix. Is your Graylog server (${AppConfig.gl2ServerUrl()}) running and reachable?`
    );
  }
};
export default setAssetPrefix;
